import {
    Service,
    ServiceDocumentData,
    ServiceQueryDocumentSnapshot,
    UpdateServiceData,
    UpdateServiceResult
} from "./types";
import firebase from "firebase/app";
import {findIndex} from "lodash";

const serviceDataConverter: firebase.firestore.FirestoreDataConverter<ServiceDocumentData> = {
    fromFirestore(snapshot: ServiceQueryDocumentSnapshot): Service {
        return {
            id: snapshot.id,
            ...snapshot.data()
        }
    },
    toFirestore(modelObject: ServiceDocumentData): ServiceDocumentData {
        return modelObject;
    }
}

export class ServicesService {
    private static GetCollection() {
        return firebase.firestore()
            .collection('services')
            .withConverter(serviceDataConverter);
    }

    async createService(serviceDocData: ServiceDocumentData): Promise<Service> {

        const collection = ServicesService.GetCollection();

        const itemCount = (await collection.get()).size;

        const newServiceDocRef = await ServicesService.GetCollection().add({...serviceDocData, position: itemCount});
        return {id: newServiceDocRef.id, ...serviceDocData, position: itemCount}
    }

    async updateService(serviceId: string, changes: UpdateServiceData): Promise<UpdateServiceResult> {
        await ServicesService.GetCollection().doc(serviceId).update(changes);
        return {
            id: serviceId,
            ...changes
        }
    }

    async listServices(): Promise<Service[]> {
        const querySnapshots = await ServicesService.GetCollection().get();
        return querySnapshots.empty
            ? []
            : querySnapshots.docs.map(d => ({
                id: d.id,
                ...d.data()
            }))
    }

    async getService(serviceId: string): Promise<Service> {
        const docData = await ServicesService.GetCollection().doc(serviceId).get();
        const serviceData = docData.data();

        if (serviceData) {
            return (
                {
                    id: docData.id,
                    ...serviceData
                }
            )
        } else {
            throw new Error('404')
        }
    }

    async changeServicePosition(serviceId: string, variant: "increment" | "decrement"): Promise<Service[]> {
        const querySnapshots = await ServicesService.GetCollection().get();

        if (querySnapshots.empty) {
            return [];
        }

        const allServices = querySnapshots.docs
            .map(d => ({
                id: d.id,
                ...d.data()
            }))
            .sort((a, b) => a.position - b.position);


        console.log("old services length", allServices.length);

        const indexOfServiceToChange = findIndex(allServices, (s) => s.id === serviceId);

        const oldPositionOfItemToIncrement = allServices[indexOfServiceToChange].position;

        if (variant === "increment") {
            allServices[indexOfServiceToChange].position = allServices[indexOfServiceToChange + 1].position
            allServices[indexOfServiceToChange + 1].position = oldPositionOfItemToIncrement
        } else {
            allServices[indexOfServiceToChange].position = allServices[indexOfServiceToChange - 1].position
            allServices[indexOfServiceToChange - 1].position = oldPositionOfItemToIncrement
        }

        const batch = firebase.firestore().batch();

        for (const service of allServices) {
            const serviceRef = ServicesService.GetCollection().doc(service.id)
            batch.update(serviceRef, {position: service.position})
        }

        console.log("new services length", allServices.length);

        await batch.commit();

        return allServices;
    }
}
